import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { buttonVariants, cn } from "@dosa/ui";

const plans = [
  { key: "initialMtm", i18nKey: "services.initialMtm.title", price: 250, duration: 45 },
  { key: "followUp", i18nKey: "services.followUp.title", price: 120, duration: 20 },
  { key: "postDischarge", i18nKey: "services.postDischarge.title", price: 250, duration: 45 },
  { key: "polypharmacy", i18nKey: "services.polypharmacy.title", price: 300, duration: 45 },
  { key: "chronic", i18nKey: "services.chronic.title", price: 180, duration: 30 },
];

export function PricingPage() {
  const { t } = useTranslation();
  return (
    <div className="container-app py-16 lg:py-20">
      <h1 className="text-4xl font-semibold text-charcoal-900">{t("pricing.title")}</h1>
      <p className="mt-3 max-w-2xl text-lg text-charcoal-600">{t("pricing.subtitle")}</p>

      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {plans.map((p) => (
          <div key={p.key} className="flex flex-col rounded-lg border border-charcoal-100 bg-white p-6 shadow-card">
            <h3 className="font-semibold text-charcoal-800">{t(p.i18nKey)}</h3>
            <p className="mt-4 text-3xl font-semibold text-charcoal-900">
              {p.price} <span className="text-base font-normal text-charcoal-400">{t("pricing.currency")}</span>
            </p>
            <p className="text-sm text-charcoal-400">{t("pricing.perSession")} &middot; {p.duration} {t("common.time")}</p>
            <Link to="/book-a-review" className={cn(buttonVariants({ size: "sm" }), "mt-6")}>
              {t("nav.bookReview")}
            </Link>
          </div>
        ))}
      </div>

      <p className="mt-10 max-w-2xl text-sm text-charcoal-400">{t("pricing.disclaimer")}</p>
    </div>
  );
}
